import { useMemo } from 'react';

const SPLASH_SCREEN_ID = 'splash-screen';

export const useSplashscreen = () => {
	return useMemo(() => {
		const remove = () => {
			return new Promise<void>((resolve) => {
				const splashScreen = document.getElementById(SPLASH_SCREEN_ID);
				if (splashScreen) {
					requestAnimationFrame(() => {
						splashScreen.classList.add(`${SPLASH_SCREEN_ID}-hidden`);
						setTimeout(() => {
							splashScreen.remove();
							return resolve();
						}, 300);
					});
				} else {
					return resolve();
				}
			});
		};

		const hide = async () => {
			await remove();

			const splashScreenStyle = document.getElementById(`${SPLASH_SCREEN_ID}-style`);
			if (splashScreenStyle) {
				requestAnimationFrame(() => {
					splashScreenStyle.remove();
				});
			}
		};

		return { hide };
	}, []);
};
